var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVdiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7",
    style: {
      fill: "none"
    },
    d: "M0 0h158v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5",
    transform: "translate(31.404 46.18)",
    style: {
      fill: "#0080cc"
    },
    d: "M0 0h51.783v9.811H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6",
    transform: "translate(31.404)",
    style: {
      fill: "#0080cc"
    },
    d: "M0 0h51.783v9.811H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 1",
    d: "M1 15.277h4.5l9.078 19.127 9.012-19.127h4.539L16.264 40.303h-3.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 2",
    d: "M31.779 15.277h15.754v4.075H35.859v6.4h11.679v4.075H35.859v6.4h11.679v4.075H31.779zm3.532-3.091 7.758-4.857 1.766 2.751-7.8 4.835z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 3",
    d: "M53.657 15.277h4.075v20.951h11.921v4.075h-16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 4",
    d: "M70.784 27.79a12.511 12.511 0 1 1 12.513 12.513A12.226 12.226 0 0 1 70.784 27.79zm20.946 0a8.435 8.435 0 1 0-8.433 8.438 8.146 8.146 0 0 0 8.433-8.438z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 5",
    d: "M99.881 27.79a12.2 12.2 0 0 1 12.513-12.513 12.875 12.875 0 0 1 8.9 3.506l-1.93 3.788a9.561 9.561 0 0 0-7.063-3.214 8.065 8.065 0 0 0-8.332 8.438 8.059 8.059 0 0 0 8.389 8.438 5.833 5.833 0 0 0 1.647-.216v-5.331h-5.259v-4.075h9.334V39.23a17.308 17.308 0 0 1-5.793 1.073A12.176 12.176 0 0 1 99.881 27.79z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 6",
    d: "M124.872 15.277h4.075v25.026h-4.075z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 7",
    d: "M135.884 15.277h4.075v11.559l11.44-11.546h5.74l-10.817 10.928 10.862 14.085h-5.18l-8.579-11.193-3.466 3.506v7.687h-4.075z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 8",
    d: "M87.62 55.978v-9.983h3.532a5.042 5.042 0 0 1 1.965.38 4.856 4.856 0 0 1 1.567 1.042 4.645 4.645 0 0 1 1.038 1.576 5.643 5.643 0 0 1 0 4 4.645 4.645 0 0 1-1.038 1.576 4.817 4.817 0 0 1-1.572 1.042 4.972 4.972 0 0 1-1.96.38zm1.625-1.629h1.9a3.448 3.448 0 0 0 1.325-.252 3.135 3.135 0 0 0 1.051-.7 3.091 3.091 0 0 0 .684-1.069 3.674 3.674 0 0 0 .243-1.351 3.607 3.607 0 0 0-.243-1.325 3.091 3.091 0 0 0-1.735-1.766 3.448 3.448 0 0 0-1.325-.252h-1.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 9",
    d: "M98.018 55.978v-9.983h1.616v9.983z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 10",
    d: "M101.568 50.988a5.153 5.153 0 0 1 .38-1.987 4.9 4.9 0 0 1 1.042-1.581 4.724 4.724 0 0 1 1.585-1.046 5.179 5.179 0 0 1 1.991-.38 4.963 4.963 0 0 1 1.934.366 5.435 5.435 0 0 1 1.62 1.033l-.773 1.519a4.3 4.3 0 0 0-1.25-.932 3.532 3.532 0 0 0-1.572-.349 3.58 3.58 0 0 0-1.325.247 3.033 3.033 0 0 0-1.06.689 3.259 3.259 0 0 0-.693 1.068 3.9 3.9 0 0 0 0 2.733 3.285 3.285 0 0 0 .693 1.064 3.134 3.134 0 0 0 1.055.693 3.713 3.713 0 0 0 1.351.243 2.005 2.005 0 0 0 .349-.026 2.8 2.8 0 0 0 .322-.066v-2.119h-2.106v-1.629h3.731v5.047a8.187 8.187 0 0 1-1.121.313 6.063 6.063 0 0 1-1.188.11 5 5 0 0 1-1.969-.38 4.724 4.724 0 0 1-2.609-2.627 5.214 5.214 0 0 1-.387-2.003z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 11",
    d: "M111.75 55.978v-9.983h1.625v9.983z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 12",
    d: "M114.88 47.624v-1.629h9.184v1.629h-3.775v8.354h-1.625v-8.354z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 13",
    d: "m123.062 55.977 4.641-10h1.585l4.641 10h-1.767l-.773-1.673h-5.74l-.8 1.673zm3.316-3.3h4.239l-2.124-4.57z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 14",
    d: "M135.5 55.978v-9.983h1.625v8.389h4.755v1.594z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdiLogo);
export default __webpack_public_path__ + "static/media/vdi-logo.d8de7da9d3e667178969ed666fdbda54.svg";
export { ForwardRef as ReactComponent };